<script setup lang="ts">
import type { Dealer } from '~/types/dealer.type'

const { dealer } = defineProps<{
  dealer: Dealer
}>()

const { t } = useI18n({})
</script>

<template>
  <div
    v-if="dealer?.website"
    class="text-lg font-bold"
  >
    <a
      class="hover:bg-primary-light hover:text-primary flex max-w-max flex-row items-center gap-2 rounded-lg px-2 py-1"
      :href="`https://${dealer?.website.replace('https://', '').replace('http://', '')}`"
      target="_blank"
    >
      {{ t('dealers.to_website') }}
      <img
        class="mt-1"
        src="~/assets/images/icons/chevron-right.svg"
        alt="Chevron"
      >
    </a>
  </div>
</template>
